import React from 'react';
import MedicineRichTextEditor from './MedicineRichTextEditor';

// Preserve the existing CKEditor prop/callback interface while using one stable
// lifecycle and the shared Find & Replace controls throughout the dashboard.
export default function LegacyRichTextEditor({ editor, data, config, disabled, onReady, onChange, onBlur, onFocus, onError }) {
  return <MedicineRichTextEditor content={data || ''} config={config} disabled={disabled} editorClass={editor} onReady={onReady} onChange={onChange} onBlur={onBlur} onFocus={onFocus} onError={onError} />;
}
